import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import moment from "moment";
import Sidebar from "../../../pages/Dashboard/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import config from "../../../../src/config/config";
import Loader from "../../../../src/components/Loader/Loader";
import { Noimage } from "../../../common/imagePath";
import DataTable from "react-data-table-component";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../src/common/Constant";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import CleanupConfirmationModal from "../../../../src/components/Modal/CleanupConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";
import Select from "react-select";
import * as XLSX from "xlsx";
import MaterialReactTable from "material-react-table";
import { Box, Button, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailIcon from "@mui/icons-material/Email";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-suppliers";
let PERMISSION_EDIT = "/manage-suppliers/:id";
let PERMISSION_DELETE = "delete-suppliers";
let PERMISSION_MANAGE_DELETED_SUPPLIERS = "/deleted-suppliers";
let PERMISSION_EXCEL_IMPORT = "/import-excel-suppliers";
let PERMISSION_EXCEL_EXPORT = "excelexport";
let PERMISSION_CLEANUP_OLD_SUPPLIERS = "cleanup-old-suppliers";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION =
  "/custom-field-suppliers-configuration";
let PERMISSION_EMAIL_SUPPLIERS = "email-suppliers";
let PERMISSION_MAILING_LABELS = "mailing-labels-suppliers";
// let PERMISSION_DELETE_SELECTED = "delete-selected-suppliers";

const Suppliers = () => {
  let selectData = [];
  const navigate = useNavigate();
  let pathforpdf = "";

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  const token = localStorage.getItem("Token");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [state, setState] = useState("");
  const [searchtext, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(10);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [selectedSuppliersCheckboxs, setselectedSuppliersCheckboxs] =
    useState("");
  const [selectedSuppliersCheckEmails, setselectedSuppliersCheckEmails] =
    useState("");
  const [
    selectedSuppliersCheckpathforpdf,
    setselectedSuppliersCheckpathforpdf,
  ] = useState("");
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state

  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "30px",
  //     position: "relative",
  //     // border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     // boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     // "&:hover": {
  //     //   border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     // },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     // backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     // "&:hover": {
  //     //   backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     // },
  //   }),
  // };

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  // const handleDeletePopup = (pID) => {
  //   console.log(pID);
  //   const deleteRequestParam = {
  //     supplierids: pID || selectedDataDelete,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   setShowDateFilterModal(true);

  // };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }

    const deleteRequestParam = {
      supplierids: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
  };

  const handlepdf = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.ID);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";
    // console.log("Enyer", selectedCustomerCheckboxs);
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierdetailforlabel?supplierids=${selectedCustomerCheckboxIDs}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const doc = new jsPDF();

        let position = 0;
        for (let i = 0; i < res.data.ResponseData.length; i++) {
          console.log(res.data.ResponseData.length);
          position = position + 10;
          doc.setFontSize(10);

          doc.text(
            `FirstName: ${res.data.ResponseData[i].FirstName}`,
            10,
            position
          );
          position = position + 10;
          doc.text(
            `LastName: ${res.data.ResponseData[i].LastName}`,
            10,
            position
          );
          position = position + 10;
          doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
          position = position + 10;
          doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
          position = position + 10;
          doc.text(
            `Address1: ${res.data.ResponseData[i].Address1}`,
            10,
            position
          );
          console.log(res.data.ResponseData);

          position = position + 10;

          if ((i + 1) % 4 == 0) {
            doc.addPage();
            position = 0;
          } else if (i == res.data.ResponseData.length - 1) {
          }
        }
        //   doc.deletePage(Last);
        doc.save(`Suppliers_mailing_label${Date.now()}.pdf`);
        setState({ data: res.data.ResponseData });
      });
  };

  const contextActions = useMemo(() => {
    const handlepdf = () => {
      console.log("Enyer", selectedSuppliersCheckboxs);
      axios
        .get(
          `${config.suppliersBaseUrl}/suppliers/supplierdetailforlabel?supplierids=${selectedSuppliersCheckboxs}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const doc = new jsPDF();
          console.log("hvjhk", res.data.ResponseData);

          let position = 0;
          for (let i = 0; i < res.data.ResponseData.length; i++) {
            position = position + 10;
            doc.setFontSize(10);

            doc.text(
              `FirstName: ${res.data.ResponseData[i].Firstname}`,
              10,
              position
            );
            position = position + 10;
            doc.text(
              `Address1: ${res.data.ResponseData[i].Address1}`,
              10,
              position
            );
            position = position + 10;
            doc.text(
              `Address2: ${res.data.ResponseData[i].Address2}`,
              10,
              position
            );
            position = position + 10;
            doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
            position = position + 10;
            doc.text(`State: ${res.data.ResponseData[i].State}`, 10, position);
            console.log("asdasd", res.data.ResponseData[i]);

            position = position + 10;
            doc.text(`Zip: ${res.data.ResponseData[i].Zip}`, 10, position);
            position = position + 10;
            doc.text(
              `Country: ${res.data.ResponseData[i].Country}`,
              10,
              position
            );
            position = position + 10;

            if (i % 3 == 0 && i >= 3) {
              console.log("i", i++);
              doc.addPage();
              position = 0;
            }
          }
          //   doc.deletePage(Last);
          doc.save(`Suppliers_mailing_labels${Date.now()}.pdf`);
          setState({ data: res.data.ResponseData });
        });
    };
    return (
      <>
        <div className="row px-2 ">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_EMAIL_SUPPLIERS) ? (
              <a href={"mailto:" + selectedSuppliersCheckEmails}>
                <button type="button" className="btn btn-dark btn-sm ">
                  <i className="fa fa-envelope fa-sm" /> E-mail
                </button>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="row px-2">
          <div className="col-12 align-self-center">
            {/* <a href={"/mailing_labels/" + selectedSuppliersCheckpathforpdf}> */}
            {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
              <button
                type="button"
                className="btn btn-dark btn-sm"
                title="MailingLabels"
                onClick={handlepdf}
              >
                <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
              </button>
            ) : (
              ""
            )}
            {/* </a> */}
          </div>
        </div>
        {/* <a href={"mailto:" + selectedSuppliersCheckEmails}> */}
        {checkUserPermission(PERMISSION_DELETE) ? (
          <button
            type="button"
            className="btn btn-danger btn-sm pull-left "
            data-bs-toggle="modal"
            data-bs-target="#DeleteConfirmationModal"
            onClick={() => handleDeletePopup()}
          >
            <i className="fa fa-trash fa-sm" /> Delete Selected
          </button>
        ) : (
          ""
        )}
        {/* </a> */}
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.ID));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.ID);
  //     console.log(e.selectedRows.map((x) => x.ID));
  //     const selectedSuppliersCheckboxIDs =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     const selectedDataDelete =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setSelectedDataDelete(selectedDataDelete);
  //     setselectedSuppliersCheckboxs(selectedSuppliersCheckboxIDs);
  //     const datasplitforpath = selectedSuppliersCheckboxIDs?.split(",");
  //     pathforpdf = datasplitforpath?.join("~");
  //     setselectedSuppliersCheckpathforpdf(pathforpdf);
  //     console.log("Datasasasa", pathforpdf);
  //     setSelectedRows(e.selectedRows.map((x) => x.Email));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Email);
  //     const selectedSuppliersCheckboxEmails =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedSuppliersCheckEmails(selectedSuppliersCheckboxEmails);
  //     console.log(selectedSuppliersCheckboxEmails);
  //   }
  // };
  //   Get all Suppliers data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate
  ) => {
    setLoading(true);
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers?pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&enddate=${endingdate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res===>", res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  }, [
    quickBookOptions,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (

  //     <div class="btn-group-sm" role="group" >
  //       {checkUserPermission(PERMISSION_EDIT) && (
  //         <Link className="btn btn-primary btn-sm btn-custom-padding"
  //           to={`/manage-suppliers/${row.ID}`}
  //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //         >
  //           Edit
  //         </Link>
  //       )}
  //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
  //         <>
  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">
  //             {checkUserPermission(PERMISSION_EDIT) ? (
  //               <li>
  //                 <Link className="dropdown-item me-3" to={`/manage-suppliers/${row.ID}`}>
  //                   <i className="fa fa-edit" title="Edit"></i>Edit
  //                 </Link>
  //               </li>
  //             ) : (
  //               ""
  //             )}
  //             {checkUserPermission(PERMISSION_DELETE) ? (
  //               <li>
  //                 <Link
  //                   className="dropdown-item confirm-text"
  //                   to="#"
  //                   title="Delete"
  //                   data-bs-toggle="modal"
  //                   data-bs-target="#DeleteConfirmationModal"
  //                   onClick={() => handleDeletePopup(row.ID)}
  //                 >
  //                   <i
  //                     className="fa fa-trash"
  //                     data-bs-toggle="tooltip"
  //                     title="Delete"
  //                   ></i>
  //                   Delete
  //                 </Link>
  //               </li>
  //             ) : (
  //               ""
  //             )}
  //           </div>
  //         </>
  //       )}
  //     </div>
  //   ),
  //   ignoreRowClick: true,
  //   allowOverflow: true,
  //   button: true,
  //   //width: "7%",//"100px",
  //   minWidth: "90px",
  //   width: "90px",
  // },
  // // {
  // //   name: "Sr No.",
  //   selector: (row, index) => index + 1,
  //   sortable: false,
  //   width:"100px"
  // },
  //       <div class="btn-group-sm" role="group" >
  //         <Link className="btn btn-primary btn-sm btn-custom-padding"
  //           to={`/manage-suppliers/${row.ID}`}
  //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //         >
  //           Edit
  //         </Link>

  //         <button
  //           type="button"
  //           className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //           data-bs-toggle="dropdown"
  //           aria-haspopup="true"
  //           aria-expanded="false"
  //           style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //         >
  //         </button>
  //         <div className="dropdown-menu">
  //           {checkUserPermission(PERMISSION_EDIT) ? (
  //             <li>
  //               <Link className="dropdown-item me-3" to={`/manage-suppliers/${row.ID}`}>
  //                 <i className="fa fa-edit" title="Edit"></i>Edit
  //               </Link>
  //             </li>
  //           ) : (
  //             ""
  //           )}
  //           {checkUserPermission(PERMISSION_DELETE) ? (
  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ID)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>
  //                 Delete
  //               </Link>
  //             </li>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     //width: "7%",//"100px",
  //     minWidth: "90px",
  //     width: "90px",
  //   },
  //   // {
  //   //   name: "Sr No.",
  //   //   selector: (row, index) => index + 1,
  //   //   sortable: false,
  //   //   width:"100px"
  //   // },
  //   {
  //     name: "Company Name",
  //     selector: "Companyname",
  //     sortable: true,
  //     width: "173px",
  //     cell: (row) => (
  //       <>
  //         {/* //  <Link className="me-3" to={`//manage-suppliers/${row.Id}`}></Link> */}
  //         {checkUserPermission(PERMISSION_EDIT) ? (
  //           <Link className="me-3 text-warning" to={`/manage-suppliers/${row.ID}`}>
  //             {row.Companyname}
  //           </Link>
  //         ) : (
  //           ""
  //         )}
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Name",
  //     // selector: (row) => row.FirstName + " " + row.LastName,
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.FirstName + " " + row.LastName}>
  //         {row.FirstName + " " + row.LastName}
  //       </p>
  //     ),
  //     sortable: true,
  //     width: "160px",
  //   },
  //   {
  //     name: "E-Mail",
  //     // selector: "Email",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Email}>
  //         {row.Email}
  //       </p>
  //     ),
  //     sortable: true,
  //     width: "155px",
  //   },
  //   {
  //     name: "Phone No.",
  //     selector: "PhoneNumber",
  //     sortable: true,
  //     width: "145px",
  //   },

  //   {
  //     name: "Profile",
  //     selector: "SelectImage",
  //     sortable: true,
  //     width: "100px",
  //     cell: (row) => (
  //       <>
  //         <img
  //           src={row.SelectImage}
  //           alt="Profile Image"
  //           style={{
  //             maxWidth: "30px",
  //             maxHeight: "70px",
  //             margin: "5px",
  //           }}
  //           onError={(e) => {
  //             e.target.onerror = null;
  //             e.target.src = Noimage;
  //           }}
  //         />
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Created Date",
  //     selector: (row) => formatDate(row.CreatedDate),
  //     sortable: true,
  //     width: "155px",
  //   },
  //   {
  //     name: "Opening Balance",
  //     selector: (row) => parseFloat(row.Openingbalance).toFixed(2),
  //     sortable: true,
  //     width: "183px",
  //   },
  //   {
  //     name: "Account Balance",
  //     selector: (row) => parseFloat(row.Balance).toFixed(2),
  //     sortable: true,
  //     width: "160px",
  //   },
  //   // {
  //   //   name: "Action",
  //   //   width: "100px",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {/* //  <Link className="me-3" to={`//manage-suppliers/${row.Id}`}></Link> */}
  //   //       {checkUserPermission(PERMISSION_EDIT) ? (
  //   //         <Link className="me-3" to={`/manage-suppliers/${row.ID}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}

  //   //       {checkUserPermission(PERMISSION_DELETE) ? (
  //   //         <Link
  //   //           className="confirm-text"
  //   //           to="delete"
  //   //           title="Delete"
  //   //           data-bs-toggle="modal"
  //   //           data-bs-target="#DeleteConfirmationModal"
  //   //           onClick={() => handleDeletePopup(row.ID)}
  //   //         >
  //   //           <i
  //   //             className="fa fa-trash text-red fa-2x"
  //   //             data-bs-toggle="tooltip"
  //   //             title="Delete"
  //   //           ></i>
  //   //         </Link>
  //   //       ) : (
  //   //         ""
  //   //       )}
  //   //     </>
  //   //   ),
  //   //   ignoreRowClick: true,
  //   //   allowOverflow: true,
  //   //   button: true,
  //   // },
  // ];

  const columns = useMemo(() => [
    {
      header: "Company Name",
      accessorKey: "CompanyName",
      Cell: ({ row }) => (
        <>
          <Link
            className="me-3 text-warning"
            to={`/manage-suppliers/${row.original.ID}`}
          >
            {row.original.Companyname}
          </Link>
        </>
      ),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Name",
      accessorKey: "Name",
      Cell: ({ row }) => (
        <>
          <p title={row.FirstName + " " + row.LastName}>
            {row.original.FirstName} {row.original.LastName}
          </p>
        </>
      ),

      // enableGrouping: false, //do not let this column be grouped
    },
    // {
    //   header: "DATE",
    //   accessorKey: "DATE",
    //   Cell: ({row})=> moment(row.original.DATE).format('DD-MM-YYYY')
    // },
    {
      header: "E-Mail",
      accessorKey: "Email",
      Cell: ({ row }) => (
        <>
          <p title={row.original.Email}>{row.original.Email}</p>
        </>
      ),

      // enableGrouping: false, //do not let this column be grouped
    },

    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
    },
    {
      header: "Profile",
      accessorKey: "SelectImage",
      Cell: ({ row }) => (
        <>
          <a href={row.original.SelectImage} target="_blank">
            <img
              src={row.original.SelectImage}
              alt="Profile Image"
              style={{
                maxWidth: "30px",
                maxHeight: "70px",
                margin: "5px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                // style={{
                //   maxWidth: "70px",
                //   maxHeight: "70px",
                //   margin: "5px",
                // }}
                e.target.src = Noimage;
              }}
            ></img>
          </a>
        </>
      ),

      // enableGrouping: false, //do not let this column be grouped
    },

    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("DD-MM-YYYY HH:mm:ss"),
    },

    {
      header: "Opening Balance",
      accessorKey: "OpeningBalance",
      Cell: ({ row }) => parseFloat(row.original.Openingbalance).toFixed(2),
    },

    {
      header: "Account Balance",
      accessorKey: "AccountBalance",
      Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
    },
    //  {
    //   header: "Created On",
    //   accessorKey: "CreatedOn",
    //   Cell: ({row}) => formatDate(row.original.CreatedDate),
    //  },
  ]);

  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.suppliersBaseUrl}/suppliers/exportexcel`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `suppliers_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // store checkbox checked values to hide or show columns

  const handleChangeCustomStartingDate = (event) => {
    // console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  const handleQuickBookDownload = () => {
    if (
      quickBookOptions.value == undefined ||
      quickBookOptions.value == null ||
      quickBookOptions.value == ""
    ) {
    } else if (
      (startingDate === undefined || endingDate === undefined) &&
      quickBookOptions.value == 1
    ) {
      setStartingDate("");
      setEndingDate("");
    } else if (
      (startingDate === undefined || endingDate === undefined) &&
      quickBookOptions.value == 2
    ) {
      // console.log("Undefined dates");
    } else {
      axios
        .get(
          `${
            config.suppliersBaseUrl
          }/suppliers/excelexportlisting?filtertext=${""}&startdate=${startingDate}&enddate=${endingDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("res ==> ", res.data.ResponseData);

          const data =
            res.data.ResponseData.length > 0
              ? res.data.ResponseData
              : [
                  {
                    [`ID`]: null,
                    [`Name`]: null,
                    [`Company Name`]: null,
                    [`Mobile Number`]: null,
                    [`City`]: null,
                    [`Country`]: null,
                    [`Created Date`]: null,
                    [`Email`]: null,
                    [`Fax`]: null,
                    [`Opening Balance`]: null,
                    [`Phone Number`]: null,
                    [`State`]: null,
                    [`Website`]: null,
                    [`Zip`]: null,
                    [`Street`]: null,
                  },
                ];

          // Create a new workbook
          const workbook = XLSX.utils.book_new();

          // Convert the data to a worksheet
          const worksheet = XLSX.utils.json_to_sheet(data);

          // Add the worksheet to the workbook
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // Save the workbook as an Excel file
          XLSX.writeFile(
            workbook,
            `supplier_quickbook_${startingDate}_${endingDate}.xlsx`
          );
          setLoading(false);
        })
        .catch((err) => {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        });
    }
  };

  const handleSupplierEmails = (id, rows, field) => {
    let a = rows.map((el) => el.original.Email);
    console.log(a, "aaa");
    selectData[currentPage] = rows?.map((x) => x.original.Email);
    const selectedCustomerCheckboxEmails =
      selectData.length > 0 ? selectData[currentPage].toString() : "";
    setselectedSuppliersCheckEmails(selectedCustomerCheckboxEmails);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              {/* <div className="col"> */}
              <h3 className="page-title">Suppliers</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Suppliers List</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <div className="d-flex">
            {/* <div className="col-lg-12 col-md-6 col-sm-12"> */}
            <div className="d-flex" style={{ width: "100%" }}>
              {/* <div className="p-1 col-lg-2 col-md-6 col-sm-12 ">
                Search:
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control form-control-sm"
                  onChange={ChangeFilterText}
                  value={searchtext}
                ></input>
              </div> */}
              <div className="p-1 col-md-3">
                Date Filter:
                <Select
                  defaultValue={quickBookOptions}
                  onChange={(event) => {
                    handleQuickBookChange(event);
                  }}
                  options={options}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  hideSelectedOptions={true}
                  id="ExcelExport"
                  name="ExcelExport"
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
              {quickBookOptions?.value == 2 && (
                <>
                  <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                    Custom Start Date:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                    />
                  </div>
                  <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                    Custom End Date:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="EndDate"
                      name="EndDate"
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                    />
                  </div>
                  <div className="p-4 col-lg-1 col-md-6 col-sm-12">
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                </>
              )}
              <div className="p-4 col-lg-3 col-md-5 col-sm-12">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => handleQuickBookDownload()}
                  title="Export to excel for quickbook"
                  // style={{"padding":"6px 6px", fontSize:"15px"}}
                >
                  Export
                </button>
              </div>
              {/* {quickBookOptions?.value !== 2 && (
                  <>
                    <div className="p-3 col-lg-4 col-md-1 col-sm-12"></div>
                  </>
                )} */}
            </div>
            {/* </div> */}
            <div className="d-flex pull-right">
              {/* dynamically hide or show columns */}
              <div style={{ marginTop: "24px" }}>
                {checkUserPermission(PERMISSION_ADD) ? (
                  <Link
                    // className="btn btn-added pull-right"
                    className="btn btn-sm btn-primary btn-sm pull-right"
                    style={{ width: "max-content" }}
                    to={`/manage-suppliers`}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    New Supplier
                  </Link>
                ) : (
                  ""
                )}
              </div>
              <div
                className="btn-group-sm pull-right ms-2"
                style={{ marginTop: "24px" }}
              >
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark d-none"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                  {/* <span className="sr-only">Toggle Dropdown</span> */}
                </button>
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(
                      PERMISSION_MANAGE_DELETED_SUPPLIERS
                    ) ? (
                      <Link class="dropdown-item" to="/deleted-suppliers">
                        Manage Deleted Suppliers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                      <Link class="dropdown-item" to="/import-excel-suppliers">
                        Excel Import
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                      <Link
                        class="dropdown-item"
                        // to="excelexport"
                        onClick={handleExcelExport}
                      >
                        Excel Export
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_CLEANUP_OLD_SUPPLIERS) ? (
                      <Link
                        to="cleanup-old-customers"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Suppliers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_CUSTOM_FIELD_CONFIGURATION
                    ) ? (
                      <Link
                        to="/custom-field-suppliers-configuration"
                        title="Custom Field Configuration"
                        className="dropdown-item"
                      >
                        Supplier Custom Fields
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                </div>
              </div>
              {/* <div className="btn-group-sm pull-right ms-2  dropdown" style={{ marginTop: "24px" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div> */}
            </div>
          </div>
          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                 
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  // fixedHeader
                  // fixedHeaderScrollHeight="70vh"
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  //   onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
               */}
                <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions
                  renderRowActionMenuItems={({ row }) => [
                    checkUserPermission(PERMISSION_EDIT) ? (
                      <MenuItem
                        key="edit"
                        onClick={() =>
                          navigate(`/manage-suppliers/${row.original.ID}`)
                        }
                      >
                        Edit
                      </MenuItem>
                    ) : (
                      ""
                    ),

                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        // key="delete"

                        onClick={() =>
                          handleDeletePopup(row.original.ID, "", "")
                        }
                      >
                        Delete
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      {checkUserPermission(PERMISSION_EMAIL_SUPPLIERS) ? (
                        <a href={"mailto:" + selectedSuppliersCheckEmails}>
                          <Button
                            size="small"
                            disabled={
                              !table.getIsSomeRowsSelected() &&
                              !table.getIsAllRowsSelected()
                            }
                            //only export selected rows
                            // data-bs-toggle="modal"
                            // data-bs-target="#UnDeleteConfirmationModal"
                            onClick={() =>
                              handleSupplierEmails(
                                "",
                                table.getSelectedRowModel().rows,
                                "multipleRowInactive"
                              )
                            }
                            startIcon={<EmailIcon />}
                            variant="contained"
                          >
                            E-mail
                          </Button>
                        </a>
                      ) : (
                        ""
                      )}

                      {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          // data-bs-toggle="modal"
                          // data-bs-target="#UnDeleteConfirmationModal"
                          onClick={() =>
                            handlepdf(table.getSelectedRowModel().rows)
                          }
                          startIcon={<EmailIcon />}
                          variant="contained"
                        >
                          Mailing-Labels
                        </Button>
                      ) : (
                        ""
                      )}

                      {checkUserPermission(PERMISSION_EMAIL_SUPPLIERS) ? (
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected() ? (
                          <Button
                            size="small"
                            disabled={
                              !table.getIsSomeRowsSelected() &&
                              !table.getIsAllRowsSelected()
                            }
                            //only export selected rows
                            // data-bs-toggle="modal"
                            // data-bs-target="#UnDeleteConfirmationModal"
                            onClick={() =>
                              handleSupplierEmails(
                                "",
                                table.getSelectedRowModel().rows,
                                "multipleRowInactive"
                              )
                            }
                            startIcon={<EmailIcon />}
                            variant="contained"
                          >
                            E-mail
                          </Button>
                        ) : (
                          <a href={"mailto:" + selectedSuppliersCheckEmails}>
                            <Button
                              size="small"
                              disabled={
                                !table.getIsSomeRowsSelected() &&
                                !table.getIsAllRowsSelected()
                              }
                              //only export selected rows
                              // data-bs-toggle="modal"
                              // data-bs-target="#UnDeleteConfirmationModal"
                              onClick={() =>
                                handleSupplierEmails(
                                  "",
                                  table.getSelectedRowModel().rows,
                                  "multipleRowInactive"
                                )
                              }
                              startIcon={<EmailIcon />}
                              variant="contained"
                            >
                              E-mail
                            </Button>
                          </a>
                        )
                      ) : (
                        ""
                      )}

                      {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          // data-bs-toggle="modal"
                          // data-bs-target="#UnDeleteConfirmationModal"
                          onClick={() =>
                            handlepdf(table.getSelectedRowModel().rows)
                          }
                          startIcon={<EmailIcon />}
                          variant="contained"
                        >
                          Mailing-Labels
                        </Button>
                      ) : (
                        ""
                      )}

                      {checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )}

                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({ ...pagination, pageIndex: 0, pageSize: totalRows })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 10 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100, 300],
                  }}
                  // manualFiltering  // for termp comment filteron column
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmationModal
        deleteApiUrl={`${config.suppliersBaseUrl}/suppliers/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      {/* Cleanup old suppliers */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.suppliersBaseUrl}/suppliers/deletepermanantely`}
      />
    </>
  );
};

export default Suppliers;
